class CustomBox {
    constructor() {
        // DOM elements
        this.feed = document.querySelector('.Feed');
        this.allFlavors = document.querySelectorAll('.Feed__Flavor');
        this.customFlavors = document.querySelectorAll('.Box__Flavors__Custom .Flavor');
        this.dragAndDropArea = document.getElementById('drag-and-drop');
        this.scrollDownbutton = document.getElementById('scroll-button');
        this.productSectionLinks = document.querySelectorAll('.Box__Navigation .button');
        this.subscriptionLink = document.getElementById('subscription-link');
        this.overlay = document.querySelector('.Overlay');
        this.packageIndex = document.getElementById('custom-box-package-index');

        // Constants
        this.step = ['first','second','third','fourth','fifth','sixth','seventh','eighth','ninth','tenth','eleventh','twelfth'];
        this.dragAndDropEnabled = true;

        // Box state
        this.isReady = false;
        this.section = document.querySelector('.Box');
        this.container = document.querySelector('.Box__Flavors__Custom');
        this.action = document.getElementById('custom-box-action');
        // The actual checkout control lives in .Box__Footer__Row, as a
        // sibling of #custom-box-action, NOT inside it — e.g.
        // <input class="button button--primary" type="submit" value="Secure Checkout" />
        // or the subscription-only / prepaid variants (#subscription-link,
        // #prepaid-subscription-link). Grab whichever is present.
        this.submitControl = document.querySelector(
            '.Box__Footer__Row input[type="submit"], ' +
            '.Box__Footer__Row #subscription-link, ' +
            '.Box__Footer__Row #prepaid-subscription-link'
        );
        this.upsell = document.getElementById('upsell-link');
        this.flavors = [];
        this.max = this.customFlavors.length;
        
        // Initialize
        this.checkPresetParams();
        this.initInteraction();

        // Set the initial submit-button state (disabled until the box is full)
        this.updateActionButton();
        
        // Save flavors
        // this.lastOrderWrapper = document.getElementById("last-order-details");
        // this.lastOrderFlavors = this.lastOrderWrapper?.innerHTML;

        //this.bodyUpdate();
        //window.onresize = () => this.bodyUpdate();
    }

    manageLastOrderInputs() {
        
        if (!this.lastOrderFlavors) {
            return;
        }

        this.lastOrderWrapper.innerHTML = this.flavors.length === 0 ? this.lastOrderFlavors : "";
    }

    arrangeBox() {
        this.flavors.forEach((flavor, index) => {

            const flavorSource = document.getElementById(flavor);

            this.customFlavors[index].classList.add('Flavor--on');
            this.customFlavors[index].querySelector('p').innerHTML = flavorSource.dataset.flavor;
            this.customFlavors[index].querySelector('img').setAttribute('src', flavorSource.querySelector('img').src);
            this.customFlavors[index].querySelector('img').style.display = 'block';
            this.customFlavors[index].querySelector('input').setAttribute('value', flavorSource.dataset.flavor);
            this.customFlavors[index].querySelector('.Flavor__Remove').dataset.flavorIndex = index;
            this.customFlavors[index].querySelector('.Flavor__Remove').dataset.flavorId = flavor;
        });

        // Update Box
        if(this.flavors.length === 0) {
            this.isReady = false;
            this.container.classList.remove('Box__Flavors__Custom--on');
            this.packageIndex.innerHTML = this.step[0];
        }
        else if(this.flavors.length > 0 && this.flavors.length < this.max) {
            this.isReady = false;
            this.container.classList.remove('Box__Flavors__Custom--ready');
            this.container.classList.add('Box__Flavors__Custom--on');
            this.packageIndex.innerHTML = this.step[this.flavors.length];
        }
        else if(this.flavors.length === this.max) {
            this.isReady = true;
            this.container.classList.remove('Box__Flavors__Custom--on');
            this.container.classList.add('Box__Flavors__Custom--ready');
        }

        // Keep the submit button's disabled state in sync with isReady
        this.updateActionButton();
    }

    resetBox() {
        this.customFlavors.forEach(flavor => {
            flavor.classList.remove('Flavor--on');
            flavor.querySelector('p').innerHTML = '';
            flavor.querySelector('img').removeAttribute('src');
            flavor.querySelector('img').style.display = 'none';
        });
    }

    updateAllFlavors() {
        this.allFlavors.forEach(flavor => {
            (this.isReady) ? flavor.classList.add('Feed__Flavor--on-ready') : flavor.classList.remove('Feed__Flavor--on-ready');
        });
    }

    /**
     * Keep the real checkout control disabled until the box is full
     * (this.isReady === true). this.submitControl is the actual
     * <input type="submit">, #subscription-link, or
     * #prepaid-subscription-link found in .Box__Footer__Row — NOT
     * this.action, which is only the small status/"repeat last order"
     * wrapper div and was never the thing submitting the form.
     */
    updateActionButton() {
        if (!this.submitControl) {
            return;
        }

        if ('disabled' in this.submitControl) {
            this.submitControl.disabled = !this.isReady;
        }

        this.submitControl.classList.toggle('is-disabled', !this.isReady);
        this.submitControl.setAttribute('aria-disabled', String(!this.isReady));
    }

    updateBox(selectedFlavorId, action, childIndex) {

        let removalControl = false;

        switch(action) {
            case 'add':
                // Guard against exceeding the box capacity: without this,
                // the counter '+' button below can push more flavors than
                // there are custom-box slots, which crashes arrangeBox()
                // when it tries to index a slot that doesn't exist.
                if (this.flavors.length >= this.max) {
                    return;
                }
                this.flavors.push(selectedFlavorId);
                break;
            case 'remove':
                this.flavors.forEach((flavor, index) => {
                    if(flavor === selectedFlavorId && !removalControl) {
                        removalControl = true;
                        this.flavors.splice(index, 1);
                    }
                });
                this.resetBox();
                break;
            case 'removeSpecificChild':
                this.flavors.splice(childIndex, 1);
                this.resetBox();
                break;
        }
        this.arrangeBox();
        this.updateAllFlavors();
        // this.bodyUpdate(500);
    }

    initInteraction() {
        // Feed flavors
        this.allFlavors.forEach(flavor => {
            const countWrapper = flavor.querySelector('[data-count]');

            // Add to box
            flavor.querySelectorAll('.button--primary').forEach(action => {
                action.onclick = () => {
                    if(!this.isReady) {
                        flavor.classList.add('Feed__Flavor--on');
                        this.updateBox(flavor.id, 'add', 1);
                    }
                }
            });

            flavor.querySelector('.button--remove').onclick = () => {
                this.updateBox(flavor.id, 'remove', 1);
                // Unselect flavor if the product is not repeated
                if(this.flavors.indexOf(flavor.id) === -1) {
                    flavor.classList.remove('Feed__Flavor--on');
                }
            }

            // Counter
            flavor.querySelectorAll('.button--counter').forEach(button => {
                button.onclick = () => {
                    let count = parseInt(countWrapper.dataset.count);

                    // Counter logic
                    switch(button.dataset.action) {
                        case '+':
                            // Also require room left in the box overall, not
                            // just under this flavor's own per-flavor max,
                            // otherwise the box can overflow past this.max.
                            if(count < this.max && this.flavors.length < this.max) {
                                countWrapper.dataset.count = count + 1;
                                this.updateBox(flavor.id, 'add');
                            }
                            break;
                        case '-':
                            if(count > 0) {
                                countWrapper.dataset.count = count - 1;
                                this.updateBox(flavor.id, 'remove');
                            }
                            break;
                    }

                    // Check if 0 and get back
                    if(flavor.querySelector('[data-count]').dataset.count == 0) {
                        flavor.classList.remove('Feed__Flavor--on');
                        countWrapper.dataset.count = 1;
                    }
                }
            });

            // Drag and drop
            if(this.dragAndDropEnabled) {
                flavor.ondragstart = event => {
                    event.dataTransfer.setData('text/plain', event.target.id);
                    this.dragAndDropArea.classList.add('Box__DragAndDrop--on');
                };

                this.dragAndDropArea.ondragenter = event => {
                    this.dragAndDropArea.classList.add('Box__DragAndDrop--over');
                };

                this.dragAndDropArea.ondragover = event => {
                    event.preventDefault();
                    this.dragAndDropArea.classList.add('Box__DragAndDrop--over');
                };

                this.dragAndDropArea.ondragleave = event => {
                    this.dragAndDropArea.classList.remove('Box__DragAndDrop--over');
                };

                flavor.ondragend = event => {
                    this.dragAndDropArea.classList.remove('Box__DragAndDrop--on', 'Box__DragAndDrop--over');
                };

                this.dragAndDropArea.ondrop = event => {
                    if(!this.isReady) {

                        const target = document.getElementById(event.dataTransfer.getData('text/plain'));

                        target.classList.add('Feed__Flavor--on');
                        this.updateBox(target.id, 'add', 1);
                    }

                    setTimeout(() => {
                        this.dragAndDropArea.classList.remove('Box__DragAndDrop--on', 'Box__DragAndDrop--over');
                    }, 50);

                    event.preventDefault();
                };
            }
        });

        // Box flavors
        this.customFlavors.forEach(flavor => {
            flavor.querySelector('.Flavor__Remove').onclick = event => {
                event.stopPropagation();
                // Use currentTarget (the element the listener is bound to)
                // instead of target, since a click on an inner icon/span
                // would otherwise return an element with no flavorIndex.
                this.updateBox(undefined, 'removeSpecificChild', parseInt(event.currentTarget.dataset.flavorIndex));
                // Update feed
                this.allFlavors.forEach(feedFlavor => {
                    if(this.flavors.indexOf(feedFlavor.id) === -1) {
                        feedFlavor.classList.remove('Feed__Flavor--on');
                    }
                });
                event.preventDefault();
            };
        });

        // Scroll down
        this.scrollDownbutton.onclick = () => {
            return false;
        }

        // Product links
        this.productSectionLinks.forEach(link => {
            link.onclick = () => {

                // Implementation with overlay
                // this.overlay.dataset.target = link.dataset.target;
                // this.overlay.classList.add('Overlay--on');
                // document.body.style.overflowY = 'hidden';

                const INCREMENT = 200;
                const target = document.querySelector(`[data-section-id="${link.dataset.contentTarget}"]`);
                const flavorFeed = document.querySelector('.Feed').getBoundingClientRect();
                const targetTop = Math.floor(flavorFeed.height);

                window.scrollTo({
                    top: targetTop + INCREMENT,
                    behavior: 'smooth'
                });
            }
        });

        // Subscription
        if(this.subscriptionLink) {
            this.subscriptionLink.onclick = event => {
                this.overlay.dataset.target = event.target.dataset.target;
                this.overlay.classList.add('Overlay--on', 'Overlay--subscription');
                document.body.style.overflowY = 'hidden';
                return false;
            }
        }

        // Overlay
        this.overlay.querySelectorAll('[data-action="close"]').forEach(action => {
            action.onclick = () => {
                this.overlay.classList.remove('Overlay--on');
                document.body.style.overflowY = 'auto';
                setTimeout(() => {
                    this.overlay.dataset.target = '';
                }, 500);
            }
        });

        // Upsell link
        if(this.upsell) {
            this.upsell.onclick = () => {
                let newHref = this.upsell.getAttribute('href') + '?';

                this.flavors.forEach((flavor, index) => {
                    newHref += (index > 0) ? '&' : '';
                    newHref += encodeURIComponent('fl' + index + '=' + document.getElementById(flavor).querySelector('h3').innerHTML);
                });

                this.upsell.setAttribute('href', newHref);
                window.location = newHref;

                return false;
            }
        }

        // Guard the real checkout control so it can't be triggered before
        // the box is fully built (this.isReady). Registered with capture:true
        // so this runs BEFORE the subscription-link overlay handler further
        // down (or the native form submit), letting us stop it in time.
        if (this.submitControl) {
            this.submitControl.addEventListener('click', event => {
                if (!this.isReady) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    return false;
                }
            }, true);
        }
    }

    stickyBox() {
        const boxProps = this.section.getBoundingClientRect();
        const wrapper = document.querySelectorAll('[data-section-id="product-custom-box-template"]')[0];

        // Check if box is not visible
        if(document.documentElement.scrollTop > (boxProps.top + boxProps.height)) {
            wrapper.style.paddingTop = (boxProps.top + boxProps.height + 180) + 'px';
            this.section.classList.add('Box--sticky');
        }
        else {
            this.section.classList.remove('Box--sticky');
            wrapper.style.paddingTop = '0px';
        }
    }

    bodyUpdate(interval) {
        setTimeout(() => {
            const boxProps = this.section.getBoundingClientRect();
            this.feed.style.paddingTop = (boxProps.height + boxProps.top) + 'px';
        }, interval || 0);
    }

    checkPresetParams() {

        let flavors = {};
        const vars = decodeURIComponent(window.location.href).replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
            flavors[key] = value;
        });

        for(let i = 0; i < 10; i++) {
            if(flavors['fl' + i]) {
                document.querySelectorAll('.Feed__Flavor').forEach(flavor => {
                    if(flavor.querySelector('h3').innerHTML?.toLowerCase() === flavors['fl' + i]?.toLowerCase()) {
                        flavor.classList.add('Feed__Flavor--on');
                        this.updateBox(flavor.id, 'add', 1);
                    }
                });
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    
    const customBox = new CustomBox();

    // window.onscroll = () => {
    //     customBox.stickyBox();
    // };
});